import { useContext, useState } from 'react';
import { MBButton } from '@shared/components/MBButton';
import { View } from '@shared/components/View';
import { ColorThemeContext, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { QRCode } from './QRCode';

interface Props {
  url: string;
  onCopyQr(data: string): void;
  onCopyLink(uri: string): void;
}

export function ShareQRCodeSection({ url, onCopyLink }: Props) {
  const colors = useContext(ColorThemeContext);
  const [showSuccessButton, setShowSuccessButton] = useState(false);

  const copyLinkClicked = () => {
    onCopyLink(url);
    setShowSuccessButton(true);
    setTimeout(() => {
      setShowSuccessButton(false);
    }, 2000);
  };

  return (
    <View center gap={1}>
      <QRCode size={{ width: 160 }} url={url} />
      {showSuccessButton && (
        <MBButton
          style={{ backgroundColor: colors.highlightActive }}
          title={i18n('qrCode.share.linkCopied')}
          titleColor={colors.foregroundActive}
          leftIcon={'check-filled'}
          leftIconSize={30}
          theme="normal"
          onPress={() => {}}
          leftIconColor={colors.accent}
        />
      )}
      {!showSuccessButton && (
        <MBButton
          style={{ width: grid(24) }}
          title={i18n('qrCode.share.copyLink')}
          onPress={copyLinkClicked}
          theme="tertiary"
          leftIcon={'link'}
          leftIconSize={30}
        />
      )}
    </View>
  );
}
